import { keycloakLogout } from "./keycloak";
import { isPasswordGrantMode, passwordLogout } from "./password-grant";

/** Déconnexion selon le mode d'authentification actif (sso | password). */
export function logout() {
  // passwordLogout / keycloakLogout désenregistrent l'appareil FCM en
  // best-effort avant de révoquer la session.
  if (isPasswordGrantMode()) void passwordLogout();
  else void keycloakLogout();
}
